import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  magazinePage: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  magazineDetail: { data: null, loading: false },
  dpgPage: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  dpgDetail: { data: null, loading: false },
  allModels: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  libModels: { data: [], loading: false },
  allMaterials: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  libMaterails: { data: [], loading: false },
  libLogs: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  allAuthOrgs: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  authedOrgs: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  savedFilters: { data: [], loading: false },
  statusTypes: { data: [], loading: false },
  confirm: { type: '', title: '', content: '', visible: false, loading: false },
  dialog: { type: '', visible: false, loading: false },
  search: null,
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
